import request from '@/utils/request'

// 模拟post请求--带参数
export function login(data) {
    return request({
        url: '/login',
        method: 'post',
        params: data
    })
}

export function iplogin() {
    return request({
        url: '/iplogin',
        method: 'post'
    })
}

export function logoutremote(data) {
    return request({
        url: '/api/logout/',
        method: 'post',
        params: data
    })
}

export function phoneLogin(data) {
    return request({
        url: '/phonelogin',
        method: 'post',
        params: data
    })
}

export function verifyPhone(data) {
    return request({
        url: '/verifyphone',
        method: 'post',
        params: data
    })
}

export function register(data) {
    return request({
        url: '/register',
        method: 'post',
        params: data
    })
}

export function resetpwd(data) {
    return request({
        url: '/forgetpsw',
        method: 'post',
        params: data
    })
}

export function wxlogin(data) {
    return request({
        url: '/wxmlogin',
        method: 'post',
        params: data
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/captcha/captchaImage',
        headers: {
            isToken: false
        },
        method: 'get',
        timeout: 20000
    })
}